import React from "react";
import "./About.css";
import { greeting } from "../../portfolio";
import Button from "../../components/button/Button";
import { aboutSection } from "../../portfolio";
import { Fade } from "react-reveal";


export default function About() {
  return (
    <div className="main" id="about">
      <div className="about-main-div">
        <Fade right duration={1000}>
        <div className="about-text-div">
          <h1 className="about-heading">{aboutSection.title} </h1>
          <h3 className="subTitle about-text-subtitle">{aboutSection.subTitle}</h3>
          <p className="subTitle about-text-subtitle">{aboutSection.subTitle1}</p>
          <p className="subTitle about-text-subtitle">{aboutSection.subTitle2}</p>
          <p className="subTitle about-text-subtitle">{aboutSection.subTitle3}</p>
          <p className="subTitle about-text-subtitle">{aboutSection.subTitle4}</p>
          <p className="subTitle about-text-subtitle">{aboutSection.subTitle5}</p>
          <p className="subTitle about-text-subtitle">{aboutSection.subTitle6}</p> 
          <p className="subTitle about-text-subtitle">{aboutSection.subTitle7}</p> 
          <Button text="See my resume" newTab={true} href={greeting.resumeLink} />
        </div>
        </Fade>
      </div>
    </div>
  );
}
